module.exports = __webpack_public_path__ + "static/media/grape.27dad1e7.svg";